module.exports = __webpack_public_path__ + "img/2.9fdbb4f3.jpg";